import React from 'react';
import {
  HubOutlined,
  ApiOutlined,
  ExploreOutlined,
  InsightsOutlined,
} from '@mui/icons-material';

export interface AiSuggestion {
  key: string;
  icon: React.ReactNode;
  label: string;
  /** Static text, or built from the name of the page the user has open. */
  hint: string | ((pageName?: string) => string);
  /** Sent as the message when the row is clicked; may name the open page. */
  prompt: string | ((pageName?: string) => string);
}

/** The start view's four suggestions (state 1a). Copy is fixed by the design handoff. */
export const AI_SUGGESTIONS: AiSuggestion[] = [
  {
    key: 'integration',
    icon: <HubOutlined />,
    label: 'Set up an integration',
    hint: 'Shopify, Lightspeed or your ERP',
    prompt: 'How do I set up an integration?',
  },
  {
    key: 'api',
    icon: <ApiOutlined />,
    label: 'Test my API endpoints',
    hint: 'Keys, auth and a first request',
    prompt: 'Help me test my API endpoints',
  },
  {
    key: 'navigate',
    icon: <ExploreOutlined />,
    label: 'Find my way around',
    hint: 'What each part of the app is for',
    prompt: 'Help me navigate the platform',
  },
  {
    key: 'numbers',
    icon: <InsightsOutlined />,
    label: 'Explain the numbers on this page',
    hint: (pageName) => (pageName ? `Uses the ${pageName} you have open` : 'Uses the page you have open'),
    prompt: (pageName) =>
      pageName ? `Explain the key numbers on my ${pageName} page` : 'Explain the key numbers on this page',
  },
];
